
import { Node, Edge } from '@xyflow/react';

export interface NodeData extends Record<string, unknown> {
  title?: string;
  label?: string;
  selectedComponentId?: string;
  selectedComponentName?: string;
  selectedOrganizationId?: string;
  selectedOrganizationName?: string;
  codeChanges7Days?: number;
  codeChanges30Days?: number;
  deploys7Days?: number;
  uuid?: string;
  text?: string;
  textAlign?: 'left' | 'center' | 'right';
  backgroundColor?: string;
  actorText?: string;
  actorColor?: string;
  imageData?: string;
  width?: number;
  height?: number;
}

export const initialNodes: Node<NodeData>[] = [];
